'use client';

import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, type Ref, useRef } from 'react';
import { useTranslations } from 'next-intl';
import styles from './RestrictionModal.module.scss';
import { useDialogFocus } from '../../../lib/useDialogFocus';
interface RestrictionModalProps {
  open: boolean;
  onClose: () => void;
  onPrimaryClick?: () => void;
  ref?: Ref<HTMLDivElement>;
}

/**
 * AI 체험 섹션 스코프의 제한 안내 모달.
 *
 * ui-v3 Dialog(Radix)로 전환하지 않고 수제 마크업 + useDialogFocus를 쓰는 이유:
 * - 이 모달은 섹션 내부 오버레이(backdrop `position: absolute` + 섹션
 *   `overflow: hidden`)라 문서 루트 포털·fixed 기반인 Radix 구조와 맞지 않음
 * - ui-v3 DialogContent는 인라인 width(320/400px)를 강제하고 ScrollArea로
 *   children을 감싸므로 인트로 마케팅 비주얼(560px 패널)을 유지할 수 없음
 */
export const RestrictionModal = t0 => {
  const $ = _c(39);
  const {
    open,
    onClose,
    onPrimaryClick,
    ref
  } = t0;
  const t = useTranslations("intro");
  const tCommon = useTranslations("common");
  const panelRef = useRef(null);
  let t1;
  if ($[0] !== onClose || $[1] !== open) {
    t1 = {
      open,
      containerRef: panelRef,
      onEscape: onClose
    };
    $[0] = onClose;
    $[1] = open;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useDialogFocus(t1);
  if (!open) {
    return null;
  }
  let t2;
  if ($[3] !== onClose) {
    t2 = event => {
      if (event.target === event.currentTarget) {
        onClose();
      }
    };
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleBackdropClick = t2;
  let t3;
  if ($[5] !== onClose) {
    t3 = _event => {
      onClose();
    };
    $[5] = onClose;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleClose = t3;
  let t4;
  if ($[7] !== onPrimaryClick) {
    t4 = _event_0 => {
      onPrimaryClick?.();
    };
    $[7] = onPrimaryClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handlePrimary = t4;
  let t5;
  if ($[9] !== t) {
    t5 = t("aiExperience.restriction.title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <h3 id="restriction-modal-title" className={styles.title}>{t5}</h3>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("aiExperience.restriction.description");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <p id="restriction-modal-description" className={styles.description}>{t7}</p>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className={styles.textBlock}>{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== tCommon) {
    t10 = tCommon("actions.close");
    $[20] = tCommon;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== handleClose || $[23] !== t10) {
    t11 = <button type="button" onClick={handleClose} className={`${styles.button} ${styles.buttonGhost}`}>{t10}</button>;
    $[22] = handleClose;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== handlePrimary || $[26] !== onPrimaryClick || $[27] !== t) {
    t12 = onPrimaryClick ? <button type="button" onClick={handlePrimary} className={`${styles.button} ${styles.buttonPrimary}`}>{t("hero.sample")}</button> : null;
    $[25] = handlePrimary;
    $[26] = onPrimaryClick;
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <div className={styles.actions}>{t11}{t12}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t9) {
    t14 = <div ref={panelRef} tabIndex={-1} className={styles.panel}>{t9}{t13}</div>;
    $[32] = t13;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== handleBackdropClick || $[36] !== ref || $[37] !== t14) {
    t15 = <div ref={ref} className={styles.backdrop} role="dialog" aria-modal="true" aria-labelledby="restriction-modal-title" aria-describedby="restriction-modal-description" onClick={handleBackdropClick}>{t14}</div>;
    $[35] = handleBackdropClick;
    $[36] = ref;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};